export default __webpack_public_path__ + "static/media/unilapse_new_logo.0e94808a.svg";